<template>
  <div class="news-container">
    <el-row justify="center">
      <el-col :xs="24" :sm="22" :md="20" :lg="18">

        <div class="page-header pb-2 mb-4 border-bottom">
          <h1 class="h3">新闻与公告</h1>
        </div>

        <el-card shadow="never">
          <div v-loading="isLoading">

            <el-alert
              v-if="error"
              :title="error"
              type="warning"
              show-icon
              :closable="false"
              class="mt-4"
            />

            <el-space v-if="activities.length > 0" direction="vertical" alignment="stretch" class="w-100">
              <el-card
                v-for="activity in activities"
                :key="activity.id"
                shadow="hover"
                class="activity-item-card"
                @click="goToDetail(activity.id)"
              >
                <el-row :gutter="20">
                  <el-col :span="8" v-if="activity.image">
                    <img :src="activity.image" class="activity-image" :alt="activity.title">
                  </el-col>

                  <el-col :span="activity.image ? 16 : 24">
                    <h5 class="mb-1 fw-bold">{{ activity.title }}</h5>
                    <small class="text-muted">
                      {{ new Date(activity.publish_date).toLocaleDateString() }}
                    </small>
                    <p class="mb-0 mt-2 card-text-content">
                      {{ activity.content.substring(0, 250) }}
                      <span v-if="activity.content.length > 250">...</span>
                    </p>
                  </el-col>
                </el-row>
              </el-card>
            </el-space>

            <el-empty v-else-if="!isLoading" description="目前没有新的活动或公告。" />

            <div class="d-flex justify-content-center mt-4" v-if="totalActivities > pageSize">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalActivities"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handlePageChange"
              />
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PublicNewsView',
  data() {
    return {
      isLoading: true,
      activities: [],
      error: null,

      // --- 【V4.0 修改】 分页状态 ---
      totalActivities: 0,  // 总条目数
      pageSize: 5,      // (与 settings.py 中的 PAGE_SIZE 保持一致)
      currentPage: 1,   // 当前页码
    };
  },
  async mounted() {
    // 加载第一页
    await this.loadPage();
  },
  methods: {
    /**
     * 【V4.0 修改】获取活动列表 (支持分页)
     */
    async loadPage() {
      this.isLoading = true;
      this.error = null;

      // 【V4.0 修改】使用 params 对象
      const params = {
        page: this.currentPage, // 告诉后端要第几页
      };

      try {
        // 【关键】调用公开 API
        const response = await axios.get('/members/api/public/activities/', {
          params: params // (axios 会自动处理 ?page=1)
        });

        // 【V4.0 修改】保存分页数据
        this.activities = response.data.results;
        this.totalActivities = response.data.count;
        this.pageSize = 5; // (与 settings.py 一致)

      } catch (err) {
        console.error('获取公开活动列表失败:', err);
        this.error = '加载数据失败，请稍后再试。';
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * V4.0: 处理分页器点击
     */
    handlePageChange(newPage) {
      this.currentPage = newPage;
      this.loadPage(); // 加载新的一页
    },

    goToDetail(activityId) {
      // 【V4.0 占位符】
      // (我们将在下一步创建 'PublicActivityDetail' 页面
      //  并更新 router/index.js)
      this.$router.push({ name: 'PublicActivityDetail', params: { id: activityId } });
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.news-container {
  max-width: 1200px;
  margin: 2.5rem auto; /* (上下边距) */
}
.page-header .h3 {
  font-weight: 600;
}
.pb-2 { padding-bottom: 0.5rem; }
.mb-4 { margin-bottom: 1.5rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-4 { margin-top: 1.5rem; }
.mb-0 { margin-bottom: 0; }
.mb-1 { margin-bottom: 0.25rem; }
.border-bottom {
  border-bottom: 1px solid var(--el-border-color-light);
}
.d-flex {
  display: flex;
}
.justify-content-center {
  justify-content: center;
}
.fw-bold {
  font-weight: 600;
}
.text-muted {
  color: var(--el-text-color-secondary);
}
.w-100 {
  width: 100%;
}

/* (活动卡片样式 - 复用自 HomeView) */
.activity-item-card {
  cursor: pointer;
  transition: transform 0.2s ease-out;
  margin-bottom: 1rem;
}
.activity-item-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--el-box-shadow-light);
}
.activity-image {
  width: 200px;
  height: 125px;
  object-fit: cover;
  border-radius: 4px;
}
.card-text-content {
  font-size: 0.9rem;
  color: var(--el-text-color-regular);
  line-height: 1.6;
}
</style>